import { render, staticRenderFns } from "./billingRulesContainer.vue?vue&type=template&id=238daa32"
import script from "./billingRulesContainer.vue?vue&type=script&lang=js"
export * from "./billingRulesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports